import React, { useState } from 'react'

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './DropdownPanel.css'

const DropdownPanel = ({ data }) => {

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };




    return (
        <>
            {data &&
                data.map((item, index) => (
                    <Accordion key={index} className="top_header" expanded={expanded === item.type} onChange={handleChange(item.type)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className="panel_header"
                        >
                            <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                <h2>
                                    {item.type}
                                </h2>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="panel_details">
                            {item.features.map((feature, index) => (
                                <div key={index} className="row feature-line">

                                    <h4 className="col-8">{feature.key}</h4>
                                    <span className="value col-4 "> {feature.value}</span>
                                </div>

                            ))}


                        </AccordionDetails>
                    </Accordion>
                ))}
        </>
    )
}

export default DropdownPanel